// extracted by mini-css-extract-plugin
module.exports = {"root":"LimitedAccessBanner_root__111AX","text":"LimitedAccessBanner_text__ClEb5","button":"LimitedAccessBanner_button__2omck"};